import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
import { tap, lastValueFrom } from 'rxjs';
import { environment } from '@env/environment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const HH_API_BASE_URL = new InjectionToken<string>('HH_API_BASE_URL');

export interface IConfiguration {
  environment: IEnvironmentVariables;
}

export interface IEnvironmentVariables {
  appInsightsKey: string;
  platformApiBaseUrl: string;
  permissionUrls: Array<string>;
  registryUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private clientConfig: IConfiguration;
  private httpClient: HttpClient;

  constructor(handler: HttpBackend) {
    // create our own instance of the httpclient using the http-backend,
    // this allows us to bypass the http interceptor tokens.
    // see https://github.com/angular/angular/issues/20203#issuecomment-368680437
    this.httpClient = new HttpClient(handler);
  }

  loadConfig(): Promise<IConfiguration> {
    return lastValueFrom(
      this.httpClient
        .get<IConfiguration>(`${environment.apiUrl}/.well-known/client-configuration`)
        .pipe(tap((response) => (this.clientConfig = response)))
    );
  }
}
